document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined') {
    console.warn('GSAP not loaded. Search animations disabled.');
    return;
  }

  // --- 1. Inline Search Bar Animations ---
  const searchBarWrappers = document.querySelectorAll('.header__search-bar');

  searchBarWrappers.forEach(wrapper => {
    const animationType = wrapper.dataset.searchAnimation || 'scale';
    if (animationType === 'none') return;

    const searchBar = wrapper.querySelector('.field');
    if (!searchBar) return;

    const searchInput = searchBar.querySelector('.search__input');

    // Helper to check if input is focused
    const isFocused = () => document.activeElement === searchInput;

    // --- Define Animation Configs ---
    const animations = {
      scale: {
        hover: { scale: 1.02, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', duration: 0.3, ease: 'power2.out' },
        focus: { scale: 1.05, boxShadow: '0 8px 20px rgba(0,0,0,0.15)', duration: 0.4, ease: 'back.out(1.5)' },
        reset: { scale: 1, boxShadow: 'none', clearProps: 'boxShadow', duration: 0.3, ease: 'power2.out' }
      },
      shadow: {
        hover: { boxShadow: '0 0 15px rgba(255, 165, 0, 0.4)', duration: 0.3, ease: 'power2.out' },
        focus: { boxShadow: '0 0 25px rgba(255, 165, 0, 0.6)', duration: 0.4, ease: 'power2.out' },
        reset: { boxShadow: 'none', clearProps: 'boxShadow', duration: 0.3, ease: 'power2.out' }
      },
      shake: {
        hover: { x: 3, duration: 0.1, yoyo: true, repeat: 1 },
        focus: { x: 0, scale: 1.02, duration: 0.3 }, // Steady focus
        reset: { x: 0, scale: 1, duration: 0.2 }
      }
    };

    const config = animations[animationType] || animations.scale;

    // Hover Animation
    searchBar.addEventListener('mouseenter', () => {
      if (isFocused()) return;
      gsap.to(searchBar, config.hover);
    });

    searchBar.addEventListener('mouseleave', () => {
      if (isFocused()) return;
      gsap.to(searchBar, config.reset);
    });

    // Focus Animation
    if (searchInput) {
      searchInput.addEventListener('focus', () => {
        gsap.to(searchBar, config.focus);
      });

      searchInput.addEventListener('blur', () => {
        gsap.to(searchBar, config.reset);
      });
    }
  });

  // --- 2. Search Icon Animations (for Icon Style) ---
  const searchIcons = document.querySelectorAll('.header__icon--search');
  
  searchIcons.forEach(icon => {
    const animationType = icon.dataset.searchAnimation || 'scale';
    if (animationType === 'none') return;

    const iconContent = icon.querySelector('span') || icon;
    
    // Define icon-specific animations based on type if needed, 
    // but for now we'll stick to the scale/rotate for all except 'none'.
    // You could expand this switch/object later.
    
    icon.addEventListener('mouseenter', () => {
      gsap.to(iconContent, {
        scale: 1.15,
        rotation: 10,
        duration: 0.4,
        ease: 'elastic.out(1, 0.5)'
      });
    });

    icon.addEventListener('mouseleave', () => {
      gsap.to(iconContent, {
        scale: 1,
        rotation: 0,
        duration: 0.3,
        ease: 'power2.out'
      });
    });
  });
});